import { render, staticRenderFns } from "./StopClassRoom.vue?vue&type=template&id=7fa08acd&scoped=true&"
import script from "./StopClassRoom.vue?vue&type=script&lang=js&"
export * from "./StopClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./StopClassRoom.vue?vue&type=style&index=0&id=7fa08acd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa08acd",
  null
  
)

export default component.exports